import { index, integer, sqliteTable, text } from "drizzle-orm/sqlite-core";
import { accounts } from "./accounts";

export const STATEMENT_TYPES = [
  "financial_position",
  "profit_loss_comprehensive_income",
] as const;

export const STATEMENT_LINE_SELECTOR_TYPES = [
  "account_id",
  "account_number_prefix",
  "account_type",
  "exclude_account_id",
  "exclude_account_number_prefix",
] as const;

export const statementLineMappings = sqliteTable("accounting_statement_line_mappings", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  packVersion: text("pack_version").notNull(),
  statement: text("statement", { enum: STATEMENT_TYPES }).notNull(),
  lineCode: text("line_code").notNull(),
  selectorType: text("selector_type", { enum: STATEMENT_LINE_SELECTOR_TYPES }).notNull(),
  accountId: text("account_id").references(() => accounts.id),
  accountNumberPrefix: text("account_number_prefix"),
  accountType: text("account_type", {
    enum: ["asset", "liability", "income", "expense", "equity"],
  }),
  excludeReason: text("exclude_reason"),
  priority: integer("priority").notNull().default(100),
  isRequired: integer("is_required").notNull().default(0),
  isActive: integer("is_active").notNull().default(1),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyVersionIdx: index("stmt_map_company_version_idx").on(
    table.companyId,
    table.packVersion,
    table.isActive,
  ),
  accountIdx: index("stmt_map_account_idx").on(table.companyId, table.accountId),
  prefixIdx: index("stmt_map_prefix_idx").on(table.companyId, table.accountNumberPrefix),
  lineIdx: index("stmt_map_line_idx").on(table.companyId, table.packVersion, table.lineCode),
}));

export type StatementLineMapping = typeof statementLineMappings.$inferSelect;
export type NewStatementLineMapping = typeof statementLineMappings.$inferInsert;
export type StatementType = (typeof STATEMENT_TYPES)[number];
export type StatementLineSelectorType = (typeof STATEMENT_LINE_SELECTOR_TYPES)[number];
